import { BarcodeGenerationComponent } from './generation/generation.component';

export const BARCODE_DECLARATIONS: any[] = [BarcodeGenerationComponent];
